// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Roboto:wght@400;700&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `html {
    scrollbar-gutter: auto;
}

.initiative-page {
    padding-top: 100px;
}

body {
  font-family: 'Roboto', sans-serif;
  line-height: 1.6;
}

.container {
  max-width: 60em;
  margin: 0 auto;
  padding: 0 1em;
}

.container h1 {
    font-size: 32px;
}

.gallery-background {
  background-color: #f0f0f0;
  width: 100%;
  padding: 1em 0;
}

.gallery-section {
  padding: 1em;
}

.initiative-page .image-gallery {
  max-width: 30em;
  margin: auto;
  overflow: hidden;
}

.initiative-page .image-gallery-slide-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 22em;
  overflow: hidden;
}

.initiative-page .image-gallery-slide img {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
  display: block;
  margin: auto;
}

.initiative-page .image-gallery-thumbnail img {
  max-width: 5em;
  max-height: 5em;
  object-fit: cover;
  width: 100%;
  height: 100%;
}

.initiative-page .image-gallery.fullscreen .image-gallery-slide-wrapper {
  width: 100vw;
  height: 100vh;
}

.initiative-page .image-gallery.fullscreen .image-gallery-slide img {
  max-width: none;
  max-height: none;
  width: 100%;
  height: 100%;
  object-fit: contain;
}

@media (max-width: 768px) {
  .container {
    padding: 0 1em;
  }

  .initiative-page .image-gallery {
    max-width: 100%;
  }

  .initiative-page .image-gallery-slide-wrapper {
    height: auto;
  }

  .initiative-page .image-gallery-thumbnail img {
    max-width: 3em;
    max-height: 3em;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/InitiativePage.css"],"names":[],"mappings":"AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;AACtB;;AAEA;EACE,iCAAiC;EACjC,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,cAAc;AAChB;;AAEA;IACI,eAAe;AACnB;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,YAAY;AACd;;AAEA;EACE,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE;IACE,cAAc;EAChB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,cAAc;IACd,eAAe;EACjB;AACF","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Roboto:wght@400;700&display=swap');\r\n\r\nhtml {\r\n    scrollbar-gutter: auto;\r\n}\r\n\r\n.initiative-page {\r\n    padding-top: 100px;\r\n}\r\n\r\nbody {\r\n  font-family: 'Roboto', sans-serif;\r\n  line-height: 1.6;\r\n}\r\n\r\n.container {\r\n  max-width: 60em;\r\n  margin: 0 auto;\r\n  padding: 0 1em;\r\n}\r\n\r\n.container h1 {\r\n    font-size: 32px;\r\n}\r\n\r\n.gallery-background {\r\n  background-color: #f0f0f0;\r\n  width: 100%;\r\n  padding: 1em 0;\r\n}\r\n\r\n.gallery-section {\r\n  padding: 1em;\r\n}\r\n\r\n.initiative-page .image-gallery {\r\n  max-width: 30em;\r\n  margin: auto;\r\n  overflow: hidden;\r\n}\r\n\r\n.initiative-page .image-gallery-slide-wrapper {\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  height: 22em;\r\n  overflow: hidden;\r\n}\r\n\r\n.initiative-page .image-gallery-slide img {\r\n  max-width: 100%;\r\n  max-height: 100%;\r\n  object-fit: contain;\r\n  display: block;\r\n  margin: auto;\r\n}\r\n\r\n.initiative-page .image-gallery-thumbnail img {\r\n  max-width: 5em;\r\n  max-height: 5em;\r\n  object-fit: cover;\r\n  width: 100%;\r\n  height: 100%;\r\n}\r\n\r\n.initiative-page .image-gallery.fullscreen .image-gallery-slide-wrapper {\r\n  width: 100vw;\r\n  height: 100vh;\r\n}\r\n\r\n.initiative-page .image-gallery.fullscreen .image-gallery-slide img {\r\n  max-width: none;\r\n  max-height: none;\r\n  width: 100%;\r\n  height: 100%;\r\n  object-fit: contain;\r\n}\r\n\r\n@media (max-width: 768px) {\r\n  .container {\r\n    padding: 0 1em;\r\n  }\r\n\r\n  .initiative-page .image-gallery {\r\n    max-width: 100%;\r\n  }\r\n\r\n  .initiative-page .image-gallery-slide-wrapper {\r\n    height: auto;\r\n  }\r\n\r\n  .initiative-page .image-gallery-thumbnail img {\r\n    max-width: 3em;\r\n    max-height: 3em;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
